import { Button, useToast } from '@chakra-ui/react';
import AdminPageShell from '../../../components/layout/AdminPageShell';
import ModelsTable from '../../../components/Models/ModelsTable.js';
import { columnsDataModels } from './variables/columnsDataModels.js';
import React, { useEffect, useState } from 'react';
import { getData, postData, putData } from '../../../utils/httpClient.js';
import { useSearch } from '../../../contexts/SearchContext.js';
import ModelsEditModal from '../../../components/Models/ModelsEditModal.js';
import { useResetPageOnFilterChange } from '../../../hooks/useResetPageOnFilterChange.js';
import { useTableSorting } from '../../../hooks/useTableSorting.js';

export default function ModelsView() {
  const { searchQuery, resetListFilters } = useSearch(); 
  const [data, setData] = useState([]); 
  const [brands, setBrands] = useState([]);
  const [page, setPage] = useState(0); 
  const [totalPages, setTotalPages] = useState(0); 
  const [modalState, setModalState] = useState({ isOpen: false, model: null, isNew: false });
  const [rowsPerPage, setRowsPerPage] = useState(10); 
  const toast = useToast();
  const { sorting, setSorting, sortBy, sortDir, appendSortParams } = useTableSorting();

  useResetPageOnFilterChange(setPage, page, [searchQuery, rowsPerPage, sortBy, sortDir]);

  const loadData = async (dato) => {
    try {
      const params = new URLSearchParams({
        page: String(page + 1),
        limit: String(rowsPerPage),
        data: dato || '',
      });
      appendSortParams(params);
      const response = await getData(`/models?${params.toString()}`);
      setData(response?.payload?.models || []);
      setTotalPages(Math.ceil(response?.payload?.total / rowsPerPage));
    } catch (error) {
      console.error('Error fetching models:', error);
    }
  };

  const loadBrands = async () => {
    try {
      const response = await getData('/brands');
      setBrands(
        [...(response?.payload?.brands || [])].sort((a, b) =>
          String(a?.name || '').localeCompare(String(b?.name || ''), 'es', {
            sensitivity: 'base',
          }),
        ),
      );
    } catch (error) {
      console.error('Error fetching brands:', error);
    }
  };

  useEffect(() => {
    loadData(searchQuery); 
    loadBrands();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, searchQuery, rowsPerPage, sortBy, sortDir]);

  useEffect(() => {
    resetListFilters();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openNewModelModal = () => {
    setModalState({ isOpen: true, model: null, isNew: true });
  };

  const closeEditModal = () => {
    setModalState({ isOpen: false, model: null, isNew: false });
  };

  const handleCreateModel = async (newModel) => {
    try {
      await postData('/models', newModel); 
      loadData(searchQuery);
      closeEditModal();
    } catch (error) {
      toast({
        title: 'Error al crear modelo',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleUpdateModel = async (updatedModel) => {
    try {
      await putData(`/models/${updatedModel.id}`, updatedModel);
      await loadData(searchQuery); 
    } catch (error) {
      toast({
        title: 'Error al actualizar el modelo',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <AdminPageShell
      title="Modelos"
      actions={
        <Button variant="adminPrimary" size="sm" onClick={openNewModelModal}>
          Nuevo modelo
        </Button>
      }
    >
      <ModelsTable
          columnsData={columnsDataModels}
          data={data} 
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          pageSize={rowsPerPage}
          setPageSize={setRowsPerPage}
          handleUpdateModel={handleUpdateModel}
          brands={brands}
          sorting={sorting}
          onSortingChange={setSorting}
        />


      <ModelsEditModal
        isOpen={modalState.isOpen}
        onClose={closeEditModal}
        model={modalState.model}
        isNew={modalState.isNew}
        onCreate={handleCreateModel}
        onUpdate={handleUpdateModel}
        brands={brands}
      />
    </AdminPageShell>
  );
}